import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  fill: "none",
  viewBox: "0 0 12 12"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M11.5 1.608 10.392.5 6 4.892 1.608.5.5 1.608 4.892 6 .5 10.392 1.608 11.5 6 7.108l4.392 4.392 1.108-1.108L7.108 6z"
    }, null, -1)
  ])))
}
export default { render: render }